import generateUUID from '../../../utils/uuid';

export default class Identifier {

  constructor(uuid = null) {

    uuid = uuid || generateUUID();

    Object.defineProperty(this, 'id', {
      configurable: false,
      enumerable:   true,
      writable:     false,
      value:        uuid,
    });

    Object.defineProperty(this, 'toString', {
      configurable: false,
      enumerable:   false,
      writable:     false,
      value:        () => uuid,
    });

  }

}


// WEBPACK FOOTER //
// ./src/modules/editableContent/domain/Identifier.js